module.exports = __webpack_public_path__ + "static/media/1.5c03d073.jpg";